import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/components/index'
import index_pc from '@/components/indexPc'
import index_YD from '@/components/indexYd'
import demo from '@/components/demo'
import cooperation from '@/components/cooperation'
import DeclarationLetter from '@/components/DeclarationLetter'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index_pc',
      name: 'pc',
      component: index_pc
    },
    {
      path: '/index_YD',
      name: 'yd',
      component: index_YD
    },
    {
      path: '/demo',
      name: 'demo',
      component: demo
    },
    {
      path: '/DeclarationLetter',
      name: 'DeclarationLetter',
      component: DeclarationLetter
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js